import React, { FC } from 'react';
import ProgressBar from '../../atoms/progress-bar/progress-bar';

interface Props {
  spendLeftForFreeCarriage: number;
  spendLeftForFreeCarriageFormatted: string;
  subTotal: number;
}

const FreeDeliveryThreshold: FC<Props> = ({
  spendLeftForFreeCarriage,
  spendLeftForFreeCarriageFormatted,
  subTotal,
}) => {
  const calculateProgress = () => {
    if (spendLeftForFreeCarriage === 0) {
      return 100;
    }
    const freeCarriageThreshold = subTotal + spendLeftForFreeCarriage;
    return 100 - 100 * (spendLeftForFreeCarriage / freeCarriageThreshold);
  };
  const progress = calculateProgress();

  return (
    <div
      className={`flex-row rounded-md  ${
        progress >= 100 ? 'bg-light-green' : 'bg-medium-blue'
      }`}
    >
      {progress >= 100 ? (
        <p className="text-sm p-3 text-check-green">Free standard delivery!</p>
      ) : (
        <p className="text-sm p-3 text-grey-600">
          Spend another{' '}
          <span className="text-french-blue text-sm">
            {spendLeftForFreeCarriageFormatted}
          </span>{' '}
          for free standard delivery
        </p>
      )}

      <div className="p-3 pt-0">
        <ProgressBar progressPercentage={progress} />
      </div>
    </div>
  );
};

export default FreeDeliveryThreshold;
